module.exports = __webpack_public_path__ + "static/media/Path-6.9e72bb93.png";